import CharacterSheetDesktop from "./CharacterSheetDesktop";

export default CharacterSheetDesktop;
export { CharacterSheetDesktop };
